import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {IExgTab} from 'exc-tab-v2';

@Component({
  selector: 'app-tab-settings-defaultmessage',
  templateUrl: './tab-settings-defaultmessage.component.html',
  styles: [
  ]
})
export class TabSettingsDefaultmessageComponent extends ExcTranslation implements IExgTab, OnInit {

  Data: any;
  tabinstance: any;

  constructor() {
    super();
  }

  ngOnInit(): void {
  }



}
